import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import type { VerificationSelection } from "./useProxyListActions";

interface VerifyProxiesDialogProps {
  open: boolean;
  selectedCount: number;
  onClose: () => void;
  onConfirm: (selection: VerificationSelection) => void;
}

export function VerifyProxiesDialog(props: VerifyProxiesDialogProps) {
  const { open, selectedCount, onClose, onConfirm } = props;
  const [selection, setSelection] = useState<VerificationSelection>("all");

  const handleConfirm = () => {
    onConfirm(selection);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Проверка прокси</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Выберите какие прокси проверить:
        </Typography>
        <FormControl>
          <RadioGroup
            value={selection}
            onChange={(event) => setSelection(event.target.value as VerificationSelection)}
          >
            <FormControlLabel value="all" control={<Radio />} label="Все прокси" />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={`Выбранные (${selectedCount})`}
              disabled={selectedCount === 0}
            />
            <FormControlLabel value="inactive" control={<Radio />} label="Неактивные" />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Запустить проверку
        </Button>
      </DialogActions>
    </Dialog>
  );
}
